export const h ={
    "common": {
        "webSuffix": "-QIDI טק צ'ידי טכנולוגיה",
        "email": "תיבת דואר",
        "password": "מסמנה",
        "verificationCode": "קוד אימות",
        "username": "שם משתמש",
        "readAndAgree": "אני מסכים",
        "and": "ו-",
        "userAgreement": "הסכם משתמש",
        "privacyPolicy": "מדיניות פרטיות",
        "copy": "זכויות יוצרים © 2025 שומר על הבעלות",
        "sendVerificationCode": "שלח קוד אימות",
        "Sending": "שלח",
        "tryAgainInSeconds": "נסה שוב לאחר שניות",
        "userNameRequired": "הזן שם משתמש",
        "passwordInputLabel": "הזן את הסיסמה",
        "checkPasswordInputLabel": "הזן סיסמת אישור",
        "userEmailRequired": "הזן את כתובת הדוא\"ל",
        "userEmailInvalid": "הזן את כתובת הדוא\"ל הנכונה",
        "emailCodeRequired": "הזן את קוד האימות",
        "newPasswordInputLabel": "הזן סיסמה חדשה",
        "confirmPasswordInputLabel": "הזן שוב את הסיסמה",
        "passwordMismatchErrorLabel": "הזנת סיסמה שניים אינה עקבית",
        "agreementRequired": "אנא קרא ולהסכים להסכם",
        "tip": "טיפים",
        "tipAlreadyLogin": "זיהה כי אתה כבר נכנס וקפץ למרכז המשתמש בשבילך",
        "tipWelcomeBack": "ברוכים הבאים בחזרה ~",
        "tipDeleteAccountFail": "נכשל למחוק את החשבון, למחוק את ממשק החשבון סגור באופן זמני",
        "pleaseAgreeFirst": "אנא הסכים קודם",
        "agree": "הסכם",
        "refuse": "דחייה",
        "tipNeedLogin": "אנא התחבר הראשון",
        "tipChangePasswordSuccess": "שינוי הסיסמה בהצלחה וקפוץ לדף הכניסה בשבילך",
        "tipGetUserInfoSuccess": "קבלת מידע מוצלח",
        "tipGetUserInfoFail": "נכשל לקבל מידע",
        "tipLoginOut": "צאת מהכניסה",
        "delete": "מחק",
        "back": "חזרה",
        "init": "אתחול",

        "passwordInputLengthErrorLabel": "אורך הסיסמה צריך להיות בין 6 ל -20",
        "changePasswordFail": "שגיאה סיסמה מקורית",
        "tipDeleteAccountSuccess": "מחק את החשבון בהצלחה",
        "emailCodeSentSuccess": "קוד האימות נפורסם",
        "emailCodeSentFail": "קוד האימות נכשל",
        "emailLoginFail": "קוד האימות פג",
        "passwordLoginFail": "סיסמת כניסה שגיאה",
        "editUserInfoSuccess": "שינוי מידע המשתמש בהצלחה",
        "registerSuccess": "רישום מוצלח",
        "registerFail": "כישלון הרישום",
        "registerEmailExistFail": "תיבת דואר כבר קיים",

        "resMessageTip0": "מידע לא ידוע",
        "resMessageTip1": "שגיאת סיסמה",
        "resMessageTip2": "אורך הסיסמה צריך להיות בין 6 ל -20",
        "resMessageTip3": "שגיאת חשבון",
        "resMessageTip4": "קוד האימות נפורסם",
        "resMessageTip5": "קוד האימות נכשל",
        "resMessageTip6": "קוד האימות פג",
        "resMessageTip7": "שגיאת סיסמה",
        "resMessageTip8": "הסיסמה לא יכולה להיות זהה לסיסמה הישנה",
        "resMessageTip9": "תיבת דואר כבר קיים",
        "resMessageTip10": "רישום מוצלח",
        "resMessageTip11": "כישלון הרישום",
        "resMessageTip12": "שינוי מידע המשתמש בהצלחה",
        "resMessageTip13": "נכשל לשנות את מידע המשתמש",
        "resMessageTip14": "להצלחה",
        "resMessageTip15": "כישלון רכישה",
        "resMessageTip16": "שינוי הסיסמה בהצלחה",
        "resMessageTip17": "נכשל לשנות את הסיסמה",
        "resMessageTip18": "איפוס הסיסמה בהצלחה",
        "resMessageTip19": "איפוס הסיסמה נכשל",
        "resMessageTip20": "כניסה מוצלחת",
        "resMessageTip21": "כשל הכניסה",
        "resMessageTip22": "מחק את החשבון בהצלחה",
        "resMessageTip23": "נכשל למחיקת החשבון",
        "resMessageTip24": "קוד האימות שגוי",
        "noUserInfoError": "שגיאת רשת, אנא התחבר מחדש"
    },
    "changePassword": {
        "newPassword": "מסקה חדשה"
    },
    "deleteUser": {
        "tipDeleteUser": "למרבה הצער, אתה צריך לעזוב. לאחר מחקת החשבון שלך, כל הנתונים האישיים שלך ייעלמו לנצח ולא ניתן לשחזר.",
        "accountDeletionTerms": "סעיף מחיקת חשבון"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "אחזר את הסיסמה באמצעות תיבת הדואר",
        "confirmPassword": "סיסמה לאישור",
        "resettingPassword": "איפוס סיסמה",
        "resetting": "איפוס"
    },
    "login": {
        "passwordLogin": "כניסה סיסמה",
        "verifyLogin": "אימות כניסה",
        "accountRegistration": "רישום חשבון",
        "forgotPassword": "שכח את הסיסמה",
        "login": "כניסה",
        "localLogin": "כניסה מקומית",
        "loginOut": "חוץ",
        "continueOnYourWay": "המשך ללכת"
    },
    "register": {
        "registerAnAccount": "רשם חשבון",
        "register": "רישום"
    },
    "userCenter": {
        "personalInformation": "נתונים אישיים",
        "modifyInformation": "שינוי מידע",
        "changePassword": "שנה את הסיסמה",
        "cancelAccount": "מספר חשבון לבטל",
        "exitAccount": "צאת מספר החשבון",
        "change": "שינוי",
        "maxCharLimitTip": "אורך שם המשתמש לא יכול לעלות על 10 תווים סיניים",
    },
    "policies": {
        "deleteAccountPrivacy": "מחק את הסכם החשבון",
        "agreement": "פרוטוקול שימוש",
        "privacyPolicy": "מדיניות פרטיות"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "בחר את המדינה או האזור שלך",
        "recommendedVisits": "גישה מומלצת",
        "NorthAmerica": "צפון אמריקה",
        "Europe": "אירופה",
        "Asia": "אסיה",
        "Other": "אחרים",
    }
}
export const aAndL ={
    "ar": {
        "Country": "ערב",
        "Language": "ערבית"
    },
    "cs": {
        "Country": "צ'כיה",
        "Language": "צ'כית"
    },
    "de": {
        "Country": "גרמניה",
        "Language": "גרמנית"
    },
    "en": {
        "Country": "בריטניה",
        "Language": "אנגלית"
    },
    "es": {
        "Country": "ספרד",
        "Language": "ספרדית"
    },
    "fr": {
        "Country": "צרפת",
        "Language": "צרפתית"
    },
    "he": {
        "Country": "ישראל",
        "Language": "עברי"
    },
    "hu": {
        "Country": "הונגריה",
        "Language": "הונגרית"
    },
    "it": {
        "Country": "איטליה",
        "Language": "איטלקית"
    },
    "ja": {
        "Country": "יפן",
        "Language": "יפנית"
    },
    "ko": {
        "Country": "דרום קוריאה",
        "Language": "קוריאנית"
    },
    "nl": {
        "Country": "הולנד",
        "Language": "הולנדית"
    },
    "pt": {
        "Country": "פורטוגל",
        "Language": "פורטוגזית"
    },
    "pt_BR": {
        "Country": "פורטוגל (ברזיל)",
        "Language": "פורטוגזית (ברזיל)"
    },
    "ru": {
        "Country": "רוסיה",
        "Language": "רוסית"
    },
    "sv": {
        "Country": "שבדיה",
        "Language": "שוודית"
    },
    "tr": {
        "Country": "טורקיה",
        "Language": "טורקית"
    },
    "uk": {
        "Country": "אוקראינה",
        "Language": "אוקראינית"
    },
    "zh": {
        "Country": "סין",
        "Language": "סינית פשוטה"
    },
    "zh_tw": {
        "Country": "טייוואן, סין",
        "Language": "סינית מסורתית"
    },
    "Canada": {
        "Country": "קנדה",
        "Language": "אנגלית"
    },
    "United_States": {
        "Country": "ארצות הברית",
        "Language": "אנגלית"
    },
    "United_Kingdom": {
        "Country": "בריטניה",
        "Language": "אנגלית"
    },
    "EU_Countries": {
        "Country": "מדינות האיחוד האירופי",
        "Language": "אנגלית"
    },
    "Australia": {
        "Country": "אוסטרליה",
        "Language": "אנגלית"
    },
    "globalzh": {
        "Country": "גלובלי",
        "Language": "סינית פשוטה"
    },
    "globalen": {
        "Country": "גלובלי",
        "Language": "אנגלית"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/he.js